import "chartjs-plugin-dragdata";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import { FaRegCalendarAlt } from "react-icons/fa";

import { Line } from "react-chartjs-2";
import { format } from "date-fns";
import { es } from "date-fns/locale"; // Or any other locale like 'de', 'es', etc.
import { useEffect, useRef, useState } from "react";

import { withMask } from "use-mask-input";
import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";

import * as api from "helper/helper";
import toast from "react-hot-toast";
import {
  getMonthNames,
  onlyNumbers,
  roundToNearest,
  Singleton,
} from "helper/tools";
import LoadingButton from "../LoadingButton/LoadingButton";
//import FilterButton from "../FilterButton/FilterButton";

//import menuStyle from "../../../../styles/Menu.module.css";
//import TableOptionCheck from "../Productos/TableOptionCheck";

function MetaBuilder({ title, subtitle }) {
  const dateRangeRef = useRef();
  const dateRangeEleRef = useRef();

  const metaMensualRef = useRef(0);
  const diariaMetaRef = useRef([]);
  const daysLabelsRef = useRef([]);
  const modedDailyMetasRef = useRef(new Set());

  const monthsInfoRef = useRef([]);
  const yearsInfoRef = useRef([]);
  const selectedMonthIndexRef = useRef();
  const selectedYearIndexRef = useRef();

  // save ref to free days(sundays)
  const currentMonthInitialGoalsRef = useRef();

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [metaValue, setMetaValue] = useState(0);

  const [metaOro, setMetaOro] = useState(0);
  const [metaPlata, setMetaPlata] = useState(0);
  const [metaBronce, setMetaBronce] = useState(0);

  const [months, setMonths] = useState([]);
  const [years, setYears] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMetas, setIsLoadingMetas] = useState(false);
  const [niveles, setNiveles] = useState([]);

  const [titleName, setTitleName] = useState("Selecciona mes");
  const [yearName, setYearName] = useState("Selecciona año");

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
  );

  const [options, setOptions] = useState({
    responsive: true,
    plugins: {
      dragData: {
        onDragStart: (e, datasetIndex, index, value) => {
          console.log("--onDragStart ");
        },
        onDragEnd: (e, datasetIndex, index, value) => {
          console.log("--onDragEnd " + e);

          //metaMensualRef.current = recalculate();
          recalculateSimple(index, value);
        },
        onDrag: (e, datasetIndex, index, value) => {
          console.log("--onDragEnd " + e);

          return isChangeValid(index, value);
        },
        dragY: true,
        dragX: false,
        round: 0,
        magnet: {
          to: function (value) {
            // Example: Snap to the nearest 5
            return Math.round(value / 5) * 5;
          },
        },
      },
      legend: {
        position: "top",
      },
      title: {
        display: false,
        text: "Chart.js Line Chart",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Dia",
        },
      },
      y: {
        ticks: {
          // Include a dollar sign in the ticks
          callback: function (value, index, ticks) {
            return Singleton.getInstance().format(value);
          },
        },
        title: {
          display: true,
          text: "Meta Comercial",
        },
        min: 0,
        max: 1000,
        /*ticks: {
          // forces step size to be 50 units
          stepSize: 1000,
        },*/
      },
    },
  });

  const [dataChart, setDataChart] = useState({
    labels: [],
    datasets: [
      {
        label: "Meta Diaria",

        data: [],
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      /* {
        label: "Dataset 2",
        data: labels.map(
          () => 50 //faker.datatype.number({ min: -1000, max: 1000 })
        ),
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
      {
        label: "Dataset 1",
        data: [10, 30, 50, 20, 25, 44, -10],
        borderColor: "pink",
        backgroundColor: "brown",
      },
      {
        label: "Dataset 2",
        data: [100, 33, 22, 19, 11, 49, 30],
        borderColor: "orange",
        backgroundColor: "blue",
      },*/
    ],
  });

  useEffect(() => {
    fetchData();

    const yearNames = getYears(es, 2024, 5).map((year, index) => ({
      name: year,
      isSelected: index === 0,
    }));
    //setYears(yearNames);
    yearsInfoRef.current = yearNames;

    const thisYear = new Date().getFullYear().toString();
    const index = yearNames.findIndex((item) => item.name === thisYear);

    handleChangeYear(index);

    const today = new Date();
    loadMonths(today.getFullYear());

    // current month
    const date = new Date();
    date.setDate(1);
    handleChangeMonth(date.getMonth());

    loadDate();

    /*  const wideMonthNames = getMonthNames(es, today.getFullYear()).map(
          (month) => ({
            name: capitalizeText(month),
            isSelected: false,
          })
        );
        setMonths(wideMonthNames);*/

    //fetchData();

    const newPermissions = PermissionsForSection(Sections.Asociados);
    setPermissions(newPermissions);

    configureDatePicker();

    //const today = new Date();
    const daysRange = getDaysForMonth(today.getMonth(), today.getFullYear());

    //-
    const dataNew = { ...dataChart };
    dataNew.labels = daysRange;

    setDataChart(dataNew);
    /*
    const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        label: "Meta Diaria",

        data: [],*/
    //-

    /*
    const INVALID_VALUE = -1;
    const series = [];
    for (const [key, value] of Object.entries(response.data)) {
      let offset = 0;
      let newDatas = daysRange.map((day, index) => {
        if (offset >= value.length) {
          return INVALID_VALUE;
        }
        const item = value[offset];
        const dayRight = new Date(item.periodo).getDate();

        if (dayRight !== day) {
          return 0;
        }
        offset++;

        return item.total;
      });

      newDatas = newDatas.filter((value) => value !== INVALID_VALUE);

      series.push({
        name: key,
        data: newDatas,
      });
    }*/

    //  const newOptions = { ...options };
    //newOptions.chart.type = "area";

    console.log("333--");
  }, []);

  const configureDatePicker = () => {
    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const daysBack7 = new Date(now);
    daysBack7.setDate(daysBack7.getDate() - 6);
    const daysBack30 = new Date(now);
    daysBack30.setDate(daysBack30.getDate() - 29);

    const thisMonthStart = new Date(now);
    thisMonthStart.setDate(1);
    const thisMonthEnd = new Date(thisMonthStart);
    thisMonthEnd.setMonth(thisMonthEnd.getMonth() + 1);
    thisMonthEnd.setDate(-1);

    const lastMonthStart = new Date(now);
    lastMonthStart.setDate(1);
    lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);
    const lastMonthEnd = new Date(lastMonthStart);
    lastMonthEnd.setMonth(lastMonthEnd.getMonth() + 1);
    lastMonthEnd.setDate(-1);

    setStartDate(lastMonthStart);
    setEndDate(lastMonthStart);

    const lastYearStart = new Date(now);
    lastYearStart.setDate(1);
    lastYearStart.setMonth(0);
    lastYearStart.setFullYear(lastYearStart.getFullYear() - 1);

    const lastYearEnd = new Date(lastYearStart);
    lastYearEnd.setFullYear(lastYearStart.getFullYear() + 1);
    lastYearEnd.setDate(-1);

    const sameMonthDifAge = new Date(now);
    sameMonthDifAge.setDate(sameMonthDifAge.getFullYear() - 1);

    dateRangeRef.current = new window.daterangepicker(
      dateRangeEleRef.current,
      {
        locale: {
          customRangeLabel: "Rango Personalizado",
        },
        singleDatePicker: false,
        showDropdowns: true,
        showCustomRangeLabel: true,
        showWeekNumbers: true,

        minDate: startDate,
        //maxYear: now.getFullYear(), // parseInt(moment().format('YYYY'),10)

        timePicker: false,
      },
      function (start, end, label) {
        var years = 23; //moment().diff(start, 'years');
        //  alert("You are " + years + " years old!");

        setStartDate(start);
        setEndDate(end);
      },
    );

    dateRangeEleRef.current.addEventListener(
      "apply.daterangepicker",
      handleHide,
    );
  };

  const getDaysForMonth = (monthIndex, year) => {
    const date = new Date();
    date.setFullYear(year, monthIndex, 1);
    date.setHours(0, 0, 0, 0);
    const finalDays = daysInMonthFull(date, true); // 31
    return finalDays;
  };

  const arrayRange = (start, stop, step) =>
    Array.from(
      { length: (stop - start) / step + 1 },
      (value, index) => start + index * step,
    );

  // Month in JavaScript is 0-indexed (January is 0, February is 1, etc),
  // but by using 0 as the day it will give us the last day of the prior
  // month. So passing in 1 as the month number will return the last day
  // of January, not February
  function daysInMonth(month, year, ignoreSunday = false) {
    const date = new Date(year, month, 0);
    const dayNo = date.getDate();
    const dayWeekNo = date.getDay();
    // where 0 represents Sunday.
    const SundayNo = 0;
    const InvalidDay = 0;
    if (!ignoreSunday) return dayNo;

    return dayWeekNo === SundayNo ? InvalidDay : dayNo;
  }

  function daysInMonthFull(nextDate, ignoreSunday = false) {
    const SundayNo = 0;
    const InvalidDay = null;

    const date = new Date(nextDate.getFullYear(), nextDate.getMonth() + 1, 0);
    const dayNo = date.getDate();

    let dayRange = arrayRange(1, dayNo, 1);
    let finishDays = dayRange.map((value, index) => {
      const aDate = new Date(
        nextDate.getFullYear(),
        nextDate.getMonth(),
        value,
      );
      const dayWeekNo = aDate.getDay();

      if (!ignoreSunday) return dayNo;

      return dayWeekNo === SundayNo ? InvalidDay : value;
    });

    currentMonthInitialGoalsRef.current = finishDays;

    return finishDays.filter((value) => value !== InvalidDay);
  }

  const handleHide = (ev) => {
    console.log("...>><");
  };

  const fetchData = async () => {
    const responseNiveles = await api.niveles().catch((error) => {
      toast.error("Error al pedir Niveles.");
      setIsLoading(false);
    });

    if (!responseNiveles) return;

    const autoNiveles = responseNiveles.data.map((item) => {
      return { id: item.id, nombre: item.nombre };
    });

    setNiveles(autoNiveles);

    ///

    /*
    let criteria = searchCriteria;
    /// reset pag info
    store.pagingInfoRef.resetPageInfo();
    //pagingInfoRef.current.resetPageInfo();

    criteria = store.pagingInfoRef.buildFetch(criteria);
    //criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);*/
  };

  const fetchDataMetas = async (date) => {
    //const dateRaw = date.toJSON();
    const dateRaw = format(date, "yyyy-MM-dd'T'00:00:00");

    const responseMetasNiveles = await api
      .getMetasVentasNivel(dateRaw)
      .catch((error) => {
        toast.error("Error al pedir Metas.");
        setIsLoading(false);
      });

    if (responseMetasNiveles == null) {
      toast.error("Error al pedir las Metas.");
      setIsLoading(false);
      return;
    }

    //ORO
    const metaNivelData = responseMetasNiveles.data;

    const oro = metaNivelData.find(
      (value, index) => value.nivelNombre.toUpperCase() === "ORO",
    );

    const plata = metaNivelData.find(
      (value, index) => value.nivelNombre.toUpperCase() === "PLATA",
    );

    const bronce = metaNivelData.find(
      (value, index) => value.nivelNombre.toUpperCase() === "BRONCE",
    );

    setMetaOro(oro?.meta ?? 0);
    setMetaPlata(plata?.meta ?? 0);
    setMetaBronce(bronce?.meta ?? 0);

    // meta diaria
    const responseMetasMonth = await api
      .getMonthMetasVentasMonth(dateRaw)
      .catch((error) => {
        toast.error("Error al pedir Niveles.");
        setIsLoading(false);
      });

    //ORO
    const dataMonth = responseMetasMonth.data;
    setMetaValue(dataMonth.meta);
    metaMensualRef.current = dataMonth.meta;

    const responseMetasMonthDaily = await api
      .getMonthMetasVentasDiaria(dateRaw)
      .catch((error) => {
        toast.error("Error al pedir Niveles.");
        setIsLoading(false);
      });

    if (!responseMetasMonthDaily) {
      return;
    }

    //ORO
    const dataMonthDaily = responseMetasMonthDaily.data;
    console.log("");

    const days = [];
    const metas = [];
    dataMonthDaily.forEach((daily) => {
      /*const utcDate = parseJSON(daily.fecha);
      days.push(utcDate.getDate());*/

      const aMeta = daily.meta;
      if (aMeta != null) {
        const utcDate = new Date(daily.fecha);
        days.push(utcDate.getDate());
        metas.push(aMeta);
      }
    });

    const dataNew = { ...dataChart };
    if (days.length === 0) {
      const daysRange = getDaysForMonth(date.getMonth(), date.getFullYear());
      days.length = 0;
      days.push(...daysRange);
    }
    dataNew.labels = days;

    dataNew.datasets = [
      {
        label: "Meta Diaria",

        data: metas,
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ];

    setDataChart(dataNew);
    //
    diariaMetaRef.current = metas;
    daysLabelsRef.current = days;

    updateMaxYScale(metas);

    //

    /*
    let criteria = searchCriteria;
    /// reset pag info
    store.pagingInfoRef.resetPageInfo();
    //pagingInfoRef.current.resetPageInfo();

    criteria = store.pagingInfoRef.buildFetch(criteria);
    //criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);*/
  };

  const updateMaxYScale = (metas) => {
    const MarginY = 50000;
    const maxY = Math.max(...metas);
    //adjust maxY
    const newOptions = { ...options };
    newOptions.scales.y.max = roundToNearest(maxY, 10) + MarginY;
    setOptions(newOptions);
  };

  const loadMonths = async (year) => {
    const currentMonth = new Date().getMonth();
    const wideMonthNames = getMonthNames(es).map((month, monthIndex) => ({
      name: month,
      isSelected: monthIndex === currentMonth,
    }));
    selectedMonthIndexRef.current = currentMonth;

    setMonths(wideMonthNames);
    monthsInfoRef.current = wideMonthNames;
  };

  const getYears = (locale, fromYear, rangeYears = 3) => {
    const today = new Date();

    const nowNextRange = today.getFullYear() - fromYear + rangeYears;
    if (fromYear != null) {
      today.setFullYear(fromYear);
    }
    today.setMonth(1);
    today.setDate(1);

    const years = [];
    for (let i = 0; i < nowNextRange; i++) {
      // Create a date object for the first day of each month
      // The year (2000) is arbitrary as it doesn't affect the month name
      const date = new Date(today.getFullYear() + i, 1, 1);
      years.push(format(date, "yyyy", { locale }));
    }
    return years;
  };

  const recalculate = () => {
    //reset
    modedDailyMetasRef.current.clear();

    const num = metaMensualRef.current;
    const dataNew = { ...dataChart };

    const eachDayValue = num / dataNew.labels.length;

    let dayValues = Array.from(
      { length: dataNew.labels.length },
      (value, index) => eachDayValue,
    );

    diariaMetaRef.current = dayValues;

    dataNew.datasets = [
      {
        label: "Meta Diaria",

        data: dayValues,
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ];

    //dataNew.labels = daysRange;

    setDataChart(dataNew);

    // change max scale y to auto fit
    updateMaxYScale(diariaMetaRef.current);
  };

  const isChangeValid = (index, value) => {
    const num = metaMensualRef.current;

    const modedDailyMetas = new Set(modedDailyMetasRef.current);

    modedDailyMetas.add(index);

    const diariaMeta = [...diariaMetaRef.current];
    diariaMeta[index] = value;

    //const length = diariaMeta.length;

    const changedValues = [];
    const originalSums = [];

    //https://stackoverflow.com/questions/44715210/how-to-get-index-based-value-from-set?noredirect=1&lq=1
    //let i = 0;
    let changedSums = 0;
    //let changed = 0;
    //for( let iter = diariaMetaRef.current.keys(), curs = iter.next(); !curs.done; curs = iter.next(), i++ )
    // separar valores modificados con los que no
    for (let index = 0; index < diariaMeta.length; index++) {
      const value = diariaMeta[index];

      if (modedDailyMetas.has(index)) {
        changedValues.push(value);
        changedSums += value;
      } else {
        originalSums.push(value);
      }
    }

    const leftOriginal = num - changedSums;
    return leftOriginal >= 0;
  };

  const recalculateSimple = (index, value) => {
    const num = metaMensualRef.current;
    const dataNew = { ...dataChart };

    modedDailyMetasRef.current.add(index);

    diariaMetaRef.current[index] = value;

    const length = diariaMetaRef.current.length;

    const changedValues = [];
    const originalSums = [];

    //https://stackoverflow.com/questions/44715210/how-to-get-index-based-value-from-set?noredirect=1&lq=1
    //let i = 0;
    let changedSums = 0;
    //let changed = 0;
    //for( let iter = diariaMetaRef.current.keys(), curs = iter.next(); !curs.done; curs = iter.next(), i++ )
    // separar valores modificados con los que no
    for (let index = 0; index < diariaMetaRef.current.length; index++) {
      const value = diariaMetaRef.current[index];

      if (modedDailyMetasRef.current.has(index)) {
        changedValues.push(value);
        changedSums += value;
      } else {
        originalSums.push(value);
      }
    }

    const leftOriginal = num - changedSums;
    const applyToSize = length - modedDailyMetasRef.current.size;
    if (applyToSize > 0) {
      const newChange = leftOriginal / applyToSize;

      // nuevo NO modificados
      for (let index = 0; index < diariaMetaRef.current.length; index++) {
        //const value = diariaMetaRef.current[index];

        if (!modedDailyMetasRef.current.has(index)) {
          diariaMetaRef.current[index] = newChange;
        }
      }
    }

    //diariaMetaRef.current = dayValues;

    // change max scale y to auto fit
    updateMaxYScale(diariaMetaRef.current);

    dataNew.datasets = [
      {
        label: "Meta Diaria",

        data: diariaMetaRef.current,
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ];

    dataNew.labels = daysLabelsRef.current;

    setDataChart(dataNew);
  };

  let selectedDateRange = "";
  if (startDate != null || endDate != null) {
    selectedDateRange =
      format(startDate, "MMM dd, yyyy") +
      " - " +
      format(endDate, "MMM dd, yyyy");
  }

  function handleChangeMonth(index) {
    let newMonths = [...monthsInfoRef.current];
    newMonths.forEach((month) => {
      month.isSelected = false;
    });
    newMonths[index].isSelected = true;

    selectedMonthIndexRef.current = index;

    setTitleName(newMonths[index].name);

    setMonths(newMonths);
  }

  function loadDate() {
    const date = new Date();
    date.setDate(1);
    date.setMonth(selectedMonthIndexRef.current);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);

    const yearRaw = parseInt(
      yearsInfoRef.current[selectedYearIndexRef.current].name,
    );
    date.setFullYear(yearRaw);

    fetchDataMetas(date);
  }

  function handleChangeYear(index) {
    let newYears = JSON.parse(JSON.stringify(yearsInfoRef.current));

    newYears.forEach((month) => {
      month.isSelected = false;
    });
    newYears[index].isSelected = true;

    selectedYearIndexRef.current = index;

    //setTitleName(newYears[index].name);
    setYearName(newYears[index].name);

    setYears(newYears);

    /*  const date = new Date();
    date.setDate(1);
    date.setMonth(index);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    fetchDataMetas(date);*/
  }

  async function saveMetaMensualDiaria() {
    console.log("--> saveMetaMensualDiaria");

    const metaValueRaw = onlyNumbers(metaValue);

    const date = new Date();
    date.setMonth(selectedMonthIndexRef.current);

    const yearRaw = parseInt(
      yearsInfoRef.current[selectedYearIndexRef.current].name,
    );
    date.setFullYear(yearRaw);

    const payload = {
      fecha: date,
      meta: metaValueRaw,
    };

    // meta diaria
    setIsLoading(true);
    const responseMetasMes = await api
      .createMetasVentasMensual(payload)
      .catch((error) => {
        toast.error("Error al Guardar Meta Mensual.");
        setIsLoading(false);
      });

    setIsLoading(false);
    if (responseMetasMes == null) {
      toast.error("Error al Guardar Meta Mensual.");
      return;
    }

    toast.success("Meta Mensual Actualizado.");

    //diarios
    /*
    diariaMetaRef.current,
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ];

    dataNew.labels = daysLabelsRef.current;
    */
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    const metaVentasDiarias = [];
    for (let index = 0; index < diariaMetaRef.current.length; index++) {
      const meta = diariaMetaRef.current[index];
      const day = daysLabelsRef.current[index];

      const aDate = new Date(date);
      aDate.setDate(day);

      const yearRaw = parseInt(
        yearsInfoRef.current[selectedYearIndexRef.current].name,
      );
      date.setFullYear(yearRaw);

      metaVentasDiarias.push({
        fecha: aDate,
        meta: meta === 0 ? null : meta,
      });
    }

    //
    /* aqui esta guardada la info original, usar los null porque son los que nos indicara los dias domingos que no se trabajan*/
    const indexes = currentMonthInitialGoalsRef.current.reduce((ind, el, i) => {
      if (el === null) ind.push(i);
      return ind;
    }, []);

    //let normalized = new Array(diariaMetaRef.current)
    for (let index = 0; index < indexes.length; index++) {
      const val = indexes[index];

      /*metaVentasDiarias.push({
        fecha: aDate,
        meta: meta === 0 ? null : meta,
      });*/

      const aDate = new Date(date);
      aDate.setDate(val + 1);

      metaVentasDiarias.splice(val, 0, {
        fecha: aDate,
        meta: null,
      });
    }

    //

    const payload2 = {
      metaVentasDiarias,
    };

    setIsLoading(true);
    const responseMetasDiarios = await api
      .createMonthMetasVentasDiaria(payload2)
      .catch((error) => {
        toast.error("Error al Guardar Meta Dias.");
        setIsLoading(false);
      });

    setIsLoading(false);
    if (responseMetasDiarios == null) {
      toast.error("Error al Guardar Meta Dias.");
      return;
    }

    toast.success("Metas Dias Actualizados.");

    //ORO
    /*  const dataMonth = responseMetasMonth.data;
    setMetaValue(dataMonth.meta);
    metaMensualRef.current = dataMonth.meta;

    const responseMetasMonthDaily = await api
      .getMonthMetasVentasDiaria(dateRaw)
      .catch((error) => {
        toast.error("Error al pedir Niveles.");
        setIsLoading(false);
      });
*/
  }

  async function saveMetaPorNivel() {
    console.log("--> saveMetaPorNivel");

    //
    const oro = niveles.find(
      (value, index) => value.nombre.toUpperCase() === "ORO",
    );

    const plata = niveles.find(
      (value, index) => value.nombre.toUpperCase() === "PLATA",
    );

    const bronce = niveles.find(
      (value, index) => value.nombre.toUpperCase() === "BRONCE",
    );

    const date = new Date();
    date.setMonth(selectedMonthIndexRef.current);

    const yearRaw = parseInt(
      yearsInfoRef.current[selectedYearIndexRef.current].name,
    );
    date.setFullYear(yearRaw);

    const payload = {
      metaVentasNiveles: [
        { fecha: date, meta: onlyNumbers(metaOro), nivelId: oro.id },
        { fecha: date, meta: onlyNumbers(metaPlata), nivelId: plata.id },
        { fecha: date, meta: onlyNumbers(metaBronce), nivelId: bronce.id },
      ],
    };

    setIsLoadingMetas(true);
    const responseMetasNiveles = await api
      .createMetasVentasNivel(payload)
      .catch((error) => {
        toast.error("Error al Guardar Metas Nivel.");
        setIsLoadingMetas(false);
      });

    setIsLoadingMetas(false);
    if (responseMetasNiveles == null) {
      toast.error("Error al Guardar Metas por Nivel.");
      return;
    }

    toast.success("Metas Niveles Actualizados.");
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <div className="input-group mb-3">
            {/**  <FilterButton
              ref={(el) => (filtrosRef.current = el)}
              name={"rw"}
              clearCallback={(ble) => clearCallback("ew")}
            >
              <ul
                className={`dropdown-menu ${menuStyle.height_50_scroll}`}
                aria-labelledby="dropdownMenuClickableInside"
              >
                {["rwer", "werwe"].map((item, index) => {
                  return (
                    <TableOptionCheck
                      key={index}
                      item={item}
                      onClick={handleStatusClick}
                    />
                  );
                })}
              </ul>
            </FilterButton>
           */}

            <button
              className="btn btn-secondary dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {titleName}
            </button>
            <ul className="dropdown-menu">
              {months.map((month, index) => (
                <>
                  <li key={index}>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => {
                        handleChangeMonth(index);
                        loadDate();
                      }}
                    >
                      {month.isSelected ? <b>{month.name}</b> : month.name}
                    </a>
                  </li>
                </>
              ))}
            </ul>

            <button
              className="btn btn-secondary dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {yearName}
            </button>
            <ul className="dropdown-menu">
              {years.map((year, index) => (
                <>
                  <li key={index}>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => {
                        handleChangeYear(index);
                        loadDate();
                      }}
                    >
                      {year.isSelected ? <b>{year.name}</b> : year.name}
                    </a>
                  </li>
                </>
              ))}
            </ul>

            {/**  <div
              className="input-group-text bg-info"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <span className="badge">{title}</span>
              <span className="align-baseline">{subtitle}</span>
            </div>*/}

            <input
              ref={withMask("currency", {
                groupSeparator: ",",
                digits: 0,
                numericInput: true,
                rightAlign: false,
                allowMinus: false,
                oncomplete: (re) => {
                  console.log("_____ COMPLETE");
                },
                onKeyDown: (event, buffer, caretPos, opts) => {
                  console.log("_____ onKEYDOWN");
                },
              })}
              type="text"
              className="form-control"
              id="floatingInput"
              step="500"
              min="0"
              value={metaValue}
              placeholder="Especifica Una Meta"
              inputMode="numeric"
              pattern="\d*"
              aria-label="First name"
              onChange={async (e) => {
                const aValue = onlyNumbers(e.target.value);
                setMetaValue(aValue);

                const valueRaw = e.target.value.replace(/[^0-9]/g, "");
                const num = parseInt(valueRaw);
                metaMensualRef.current = num;

                recalculate();
              }}
            />
          </div>
        </div>
        <div className="col">
          {/*}  <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              saveMetaMensualDiaria();
            }}
          >
            Actualizar
          </button>*/}

          <LoadingButton
            style={{ height: "38px" }}
            onClick={async (e) => {
              saveMetaMensualDiaria();
            }}
            text={"Actualizar"}
            loadingText={"Actualizando..."}
            isLoading={isLoading}
          />
        </div>
      </div>

      <div className="row">
        <div className="row">
          <div
            className="col card1 recent-sales overflow-auto"
            style={{
              backgroundColor: "transparent",
              borderRadius: "0px",
              marginBottom: "30px",
            }}
          >
            <form className="row g-3 card">
              <div
                id="daterange"
                ref={dateRangeEleRef}
                className="selectbox pull-right"
                onClick={() => {
                  console.log("-->>ZZZ");
                  //  dateRangeRef.current.toggle();
                }}
                style={{ display: "none" }}
              >
                <FaRegCalendarAlt style={{ fontSize: "20px" }} />
                <span>{selectedDateRange}</span> <b className="caret"></b>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="row">
        <Line datasetIdKey="id" options={options} data={dataChart} />
      </div>

      <div className="separator"></div>

      <div className="row">
        <div className="input-group mb-3 col">
          <span className="input-group-text bg-oro" id="basic-addon1">
            Meta Oro
          </span>
          <input
            ref={withMask("currency", {
              groupSeparator: ",",
              digits: 0,
              numericInput: true,
              rightAlign: false,
              allowMinus: false,
            })}
            type="text"
            className="form-control"
            id="floatingInput"
            step="500"
            min="0"
            value={metaOro}
            placeholder="Especifica Una Meta"
            inputMode="numeric"
            pattern="\d*"
            aria-label="Meta Oro"
            onChange={async (e) => {
              const aValue = onlyNumbers(e.target.value);
              setMetaOro(aValue);
            }}
          />
          {/**   <div
            className="btn-group-vertical"
            role="group"
            aria-label="Up Down Buttons"
          >
            <button type="button" className="btn btn-primary">
              ▴
            </button>
            <button type="button" className="btn btn-primary">
              ▾
            </button>
          </div>
          */}
        </div>
        <div className="col-8"></div>
      </div>
      <div className="row">
        <div className="input-group mb-3 col">
          <span className="input-group-text bg-plata" id="basic-addon1">
            Meta Plata
          </span>
          <input
            ref={withMask("currency", {
              groupSeparator: ",",
              digits: 0,
              numericInput: true,
              rightAlign: false,
              allowMinus: false,
            })}
            type="text"
            className="form-control"
            id="floatingInput"
            step="500"
            min="0"
            value={metaPlata}
            placeholder="Especifica Una Meta"
            inputMode="numeric"
            pattern="\d*"
            aria-label="Meta Plata"
            onChange={async (e) => {
              const aValue = onlyNumbers(e.target.value);
              setMetaPlata(aValue);
            }}
          />
        </div>
        <div className="col-8"></div>
      </div>
      <div className="row">
        <div className="input-group mb-3 col">
          <span className="input-group-text bg-bronce" id="basic-addon1">
            Meta Bronce
          </span>
          <input
            ref={withMask("currency", {
              groupSeparator: ",",
              digits: 0,
              numericInput: true,
              rightAlign: false,
              allowMinus: false,
            })}
            type="text"
            className="form-control"
            id="floatingInput"
            step="500"
            min="0"
            value={metaBronce}
            placeholder="Especifica Una Meta"
            inputMode="numeric"
            pattern="\d*"
            aria-label="Meta Bronce"
            onChange={async (e) => {
              const aValue = onlyNumbers(e.target.value);
              setMetaBronce(aValue);
            }}
          />
        </div>
        <div className="col-8"></div>
      </div>

      <div className="row">
        <div className="col">
          <div style={{ display: "flex" }}>
            {/*  <button
              type="button"
              className="btn btn-primary"
              style={{ flex: "1" }}
              onClick={() => {
                saveMetaPorNivel();
              }}
            >
              Actualizar
            </button>
*/}

            <LoadingButton
              style={{ height: "38px" }}
              onClick={async (e) => {
                saveMetaPorNivel();
              }}
              text={"Actualizar"}
              loadingText={"Actualizando..."}
              isLoading={isLoadingMetas}
            />
          </div>
        </div>
        <div className="col-9"></div>
      </div>
    </div>
  );
}

export default MetaBuilder;
